import { render, staticRenderFns } from "./historialIngresos.vue?vue&type=template&id=37b4f99c&scoped=true"
import script from "./historialIngresos.vue?vue&type=script&lang=js"
export * from "./historialIngresos.vue?vue&type=script&lang=js"
import style0 from "./historialIngresos.vue?vue&type=style&index=0&id=37b4f99c&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "37b4f99c",
  null
  
)

export default component.exports